import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import Footer from "@/components/feature/Footer";
import Navbar from "@/components/feature/Navbar";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面未找到｜返回五一假期事件盘点 - 瓜田速报",
    description:
      "你访问的页面暂时无法找到，可能是链接有误或内容已调整。返回五一假期事件盘点首页，继续查看最新的热点复盘与话题榜单。",
    keywords: "页面未找到,五一假期事件盘点,瓜田速报",
    canonical: "https://iosfxw.cn/",
  });

  return (
    <>
      <Navbar />
      <main className="flex min-h-[72vh] items-center bg-background-50 px-4 pt-16 md:pt-[74px]">
        <Container>
          <div className="mx-auto flex max-w-xl flex-col items-center py-16 text-center">
            <span className="font-heading text-[96px] font-black leading-none text-primary-200 md:text-[140px]">
              404
            </span>
            <h1 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
              这个页面走丢了
            </h1>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              你访问的地址可能已经调整，或者链接输入有误。不如回到盘点首页，从时间线开始重新逛一圈。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="inline-flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-home-4-line" />
                返回首页
              </Link>
              <Link
                to="/topics"
                className="inline-flex h-11 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                <i className="ri-book-open-line" />
                浏览事件盘点
              </Link>
            </div>
          </div>
        </Container>
      </main>
      <Footer />
    </>
  );
}